
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import Documents from "@/views/pages/application/document/Document.vue";
import DocumentsRO from "@/views/pages/application/view/tabs/Document.vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep4 {
  isUtilizeAcademicRecord: string;
  allAcademicRecords: string;
  isReviewed: string;
  reviewerName: string;
  approvalLetter: string;
}

export default defineComponent({
  name: "step-4",
  components: {
    Field,
    ErrorMessage,
    Documents,
    Editor,
    DocumentsRO,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    const step4 = ref<IStep4>({
      isUtilizeAcademicRecord: "0",
      allAcademicRecords: "",
      isReviewed: "0",
      reviewerName: "",
      approvalLetter: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step4.value.isUtilizeAcademicRecord = data.data.isUtilizeAcademicRecord
        ? "1"
        : "0";
      step4.value.allAcademicRecords = data.data.allAcademicRecords || "";
      step4.value.isReviewed = data.data.isReviewed ? "1" : "0";
      step4.value.reviewerName = data.data.reviewerName || "";
      step4.value.approvalLetter = data.data.approvalLetter || "";
    });

    return {
      step4,
      Documents,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
